import { useState, useEffect, useCallback } from 'react';
import GeolocationService from '../Services/GeolocationService';
import AnalyticsService, {
    AnalyticsEvents
} from '../Services/AnalyticsService';

interface UseNonUsaWarningModalReturn {
    isOpenNonUsaModal: boolean;
    isValidGeolocation: boolean;
    setIsOpenNonUsaModal: (isOpen: boolean) => void;
    handleNonUsaModal: () => void;
    checkGeolocationAndExecute: (callback: () => void) => void;
}

export const useNonUsaWarningModal = (): UseNonUsaWarningModalReturn => {
    const [isOpenNonUsaModal, setIsOpenNonUsaModal] = useState(false);
    const [isValidGeolocation, setIsValidGeolocation] = useState(true);

    useEffect(() => {
        let isMounted = true;

        GeolocationService.isFromValidCountriesPromise()
            .then(isValid => {
                if (isMounted) setIsValidGeolocation(isValid);
            })
            .catch(error => console.error(error));

        return () => {
            isMounted = false;
        };
    }, []);

    const handleNonUsaModal = useCallback(() => {
        setIsOpenNonUsaModal(true);
        AnalyticsService.track(
            AnalyticsEvents.on_boarding_non_usa_warning_view
        );
    }, []);

    const checkGeolocationAndExecute = useCallback(
        (callback: () => void) => {
            if (!isValidGeolocation) {
                handleNonUsaModal();
                return;
            }

            callback();
        },
        [isValidGeolocation, handleNonUsaModal]
    );

    return {
        isOpenNonUsaModal,
        isValidGeolocation,
        setIsOpenNonUsaModal,
        handleNonUsaModal,
        checkGeolocationAndExecute
    };
};
